import * as React from 'react';
import { IContentTitle } from './interface';
import { Box, Typography } from '@mui/material';

export const ContentTitle: React.FC<IContentTitle> = ({
  title,
  align = 'center',
  variant = 'normal',
}): JSX.Element => {
  return (
    <Box
      sx={{
        mb: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: align === 'right' ? 'end' : align,
        textTransform: 'uppercase',
      }}
    >
      <Typography
        variant="h2"
        fontSize={variant === 'normal' ? '1.2rem' : '.95rem'}
        fontWeight="bold"
        color="text.primary"
      >
        {title}
      </Typography>
      <Box
        sx={{
          mt: '5px',
          height: '3px',
          width: '4rem',
          backgroundColor: 'primary.main',
        }}
      />
    </Box>
  );
};
